/**
 * BootstrapJustRanBanner
 *
 * One-shot dismissible banner shown after the first-visit bootstrap seeds
 * suggestions. Copy per spec.
 */

import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  onDismiss: () => void;
}

export function BootstrapJustRanBanner({ onDismiss }: Props) {
  return (
    <div
      role="status"
      className="rounded-md bg-muted p-3 text-sm flex items-start justify-between gap-2 mb-4"
      data-testid="bootstrap-banner"
    >
      <span>
        I pulled a few starting points from your reflections — accept any that
        feel right.
      </span>
      <Button
        variant="ghost"
        size="icon"
        onClick={onDismiss}
        aria-label="Dismiss banner"
        className="h-6 w-6"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
